@if (restrictionInformations) {
<div class="restriction-container">
    <div class="title">
        <fa-icon [icon]="faAngleRight"></fa-icon>
        <span>
            {{ 'Restriction.Title' | translate }}
            {{ restrictionInformations.name ? '"' + restrictionInformations.name + '"' : restrictionInformations.id ? '"' + restrictionInformations.id + '"' : '' }}
        </span>
    </div>

    <div class="content">
        @if (restrictionInformations !== undefined) {
        <form [formGroup]="restrictionForm" (ngSubmit)="onSubmit()">
            <div class="form-content">
                <mat-card appearance="outlined" class="box default-card">
                    <mat-card-content>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'Restriction.NamePlaceholder' | translate }}</mat-label>
                                <input matInput formControlName="name" autocomplete="off" required />
                            </mat-form-field>
                        </div>
                        <div class="check-form-field">
                            <mat-checkbox formControlName="enabled">{{ 'GlobalRule.EnabledPlaceholder' | translate }}</mat-checkbox>
                        </div>
                        <!-- <div>
                <mat-form-field>
                  <mat-label>{{'Restriction.ExtensionPlaceholder'|translate}}</mat-label>
                  <mat-select formControlName="extensionId">
                    <mat-option *ngFor="let extension of extensions" [value]="extension.id">
                      {{extension | extensionDisplay}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div> -->
                        <div>
                            <mat-form-field style="width: 210px">
                                <mat-label>{{ 'Restriction.ExtensionPlaceholder' | translate }}</mat-label>
                                <input type="text" matInput [matAutocomplete]="auto" formControlName="extension" />
                                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayExtension" (optionSelected)="extensionsChange($event)">
                                    @for (extension of extensionsOptions | async; track extension) {
                                    <mat-option [value]="extension">
                                        {{ extension | extensionDisplay }}
                                    </mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'Restriction.CalendarPlaceholder' | translate }}</mat-label>
                                <mat-select formControlName="calendarId">
                                    @for (calendar of calendars; track calendar) {
                                    <mat-option [value]="calendar.id">
                                        {{ calendar.name }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'Restriction.TypePlaceholder' | translate }}</mat-label>
                                <mat-select formControlName="type">
                                    @for (type of restrictionTypes; track type) {
                                    <mat-option [value]="type">
                                        {{ 'EnumRestrictionTypes.' + type | translate }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'Restriction.ExpressionPlaceholder' | translate }}</mat-label>
                                <input matInput formControlName="expression" autocomplete="off" />
                            </mat-form-field>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="save-button">
                <button mat-stroked-button type="button" color="accent" routerLink="/restrictions">{{ 'Restriction.CancelButton' | translate }}</button>
                <button mat-raised-button color="accent" [disabled]="!restrictionForm.valid" type="submit">{{ 'Restriction.SubmitButton' | translate }}</button>
            </div>
        </form>
        }
    </div>
</div>
}
